module.exports = __webpack_public_path__ + "img/学院照片@2x.2561ada7.png";